export { default } from './MinimalLayout';
export * from './MinimalLayout.styled';
